import React from 'react';
import { Link, useParams } from 'react-router-dom';
import LeadAgentTimeline from './LeadAgentTimeline';
import LeadMeetingStatus from './LeadMeetingStatus';
import LeadPlannerDecision from './LeadPlannerDecision';
import LeadAgentJourney from './LeadAgentJourney';

function LeadAgentWorkspace() {
  const { id, leadId } = useParams();
  return <>
    <div style={{ maxWidth: 1180, margin: '18px auto 0', padding: '0 24px', display: 'flex', justifyContent: 'flex-end' }}>
      <Link to={`/campaigns/${id}/hybrid-flow`} className="lead-agent-button link">Hybrid flow configureren</Link>
    </div>
    <LeadMeetingStatus campaignId={id} leadId={leadId} />
    <LeadPlannerDecision campaignId={id} leadId={leadId} />
    <LeadAgentJourney campaignId={id} leadId={leadId} />
    <LeadAgentTimeline />
  </>;
}

export default LeadAgentWorkspace;
